'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createIconComponent = require('./utils/createIconComponent');

var _createIconComponent2 = _interopRequireDefault(_createIconComponent);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconBagsCategory = (0, _createIconComponent2.default)({ fillContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M21.982 6h-4.963V2l-3-2h-4l-3 2v4H1.982l.037 16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2zm-6.964-4.132l1 .667V6h-1zm-5-.868h4v1h-4zm0 2h4v3h-4zm-2-.465l1-.667V6h-1zM20.985 7l.032 14.337h-18L2.985 7zM8.613 18.989h9.905l-4.953-8.8-2.839 5.047L9.233 12.7l-3.715 6.289zm4.953-6.764l3.242 5.765h-6.485zm-3.4 4.013l-.985 1.751H7.27l1.963-3.322z' })
  ), lightContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M21.982 6h-4.963V2l-3-2h-4l-3 2v4H1.982l.037 16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2zm-6.964-4.132l1 .667V6h-1zm-5-.868h4v1h-4zm0 2h4v3h-4zm-2-.465l1-.667V6h-1zM20.985 7l.032 14.337h-18L2.985 7zM8.613 18.989h9.905l-4.953-8.8-2.839 5.047L9.233 12.7l-3.715 6.289zm4.953-6.764l3.242 5.765h-6.485zm-3.4 4.013l-.985 1.751H7.27l1.963-3.322z' })
  ), regularContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M21.982 6h-4.963V2l-3-2h-4l-3 2v4H1.982l.037 16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2zm-6.964-4.132l1 .667V6h-1zm-5-.868h4v1h-4zm0 2h4v3h-4zm-2-.465l1-.667V6h-1zM20.985 7l.032 14.337h-18L2.985 7zM8.613 18.989h9.905l-4.953-8.8-2.839 5.047L9.233 12.7l-3.715 6.289zm4.953-6.764l3.242 5.765h-6.485zm-3.4 4.013l-.985 1.751H7.27l1.963-3.322z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconBagsCategory.displayName = 'IconBagsCategory';
exports.default = IconBagsCategory;